import styled from 'styled-components';
import { TextInput } from '../TextInput';

export const SearchTextInput = styled(TextInput)`
    input[type='search'] {
        /*
        * Hide the default webkit clear button
        */
        &::-webkit-search-cancel-button {
            appearance: none;
        }
    }
`;
